import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-story-of-success',
  templateUrl: './story-of-success.component.html',
  styleUrls: ['./story-of-success.component.css']
})
export class StoryOfSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
